import script from "./UiTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiTag.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__